import { render, staticRenderFns } from "./PurchaseOK.vue?vue&type=template&id=1cf2dd0f&scoped=true&"
import script from "./PurchaseOK.vue?vue&type=script&lang=js&"
export * from "./PurchaseOK.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOK.vue?vue&type=style&index=0&id=1cf2dd0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf2dd0f",
  null
  
)

export default component.exports